import React, {useContext, useEffect, useRef, useState} from "react";
import {TranslateContext} from "./TranslateContext.jsx";

export const AlertMsgContext = React.createContext(0);

export const AlertMsgProvider = ({value, children}) => {

    const refToast = useRef();
    const {translate} = useContext(TranslateContext);

    useEffect(() => {
    }, []);

    const showMessage = (text, title, severity) => {
        refToast.current.clear();
        refToast.current.show({severity: severity, summary: title, detail: text, life: 3000});
    };

    const showErrorMessage = (text, title = translate('Attenzione')) => {
        refToast.current.clear();
        refToast.current.show({severity: 'error', summary: title, detail: text, life: 3000});
    };

    const showInfoMessage = (text, title = translate('Info')) => {
        refToast.current.clear();
        refToast.current.show({severity: 'info', summary: title, detail: text, life: 3000});
    };

    const showSuccessMessage = (text, title) => {
        refToast.current.clear();
        refToast.current.show({severity: 'success', summary: title, detail: text, life: 3000});
    };

    const clearAlert = () => {
        refToast.current.clear();
    }

    return (
        <AlertMsgContext.Provider
            value={{
                refToast,
                showMessage,
                showErrorMessage,
                showInfoMessage,
                showSuccessMessage,
                clearAlert,
            }}>{children}</AlertMsgContext.Provider>
    );
};
